import React from 'react';

export const AlmostGoneBadge = ({ className = '' }) => {
  return <p className={`almostGone--${className}`}>Almost Gone!</p>;
};
